export default __webpack_public_path__ + "static/hero_cloud_back-45fa67635c784e2e5ae3cac2d3342ac0.png";